module.exports = __webpack_public_path__ + "img/app/home/img/icon-arrow-rg-normal.5f3f26d9a9d8e0f6fa179cb82f161061.png";